import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { useContent } from '../../../content/content-provider';
import formatCard from '../../utils/formatCard';
import { RemoveButton } from '../../../common/components';
import RemoveGiftCardModal from './RemoveGiftCardModal';

const styles = makeStyles(({ spacing }) => ({
  removeButton: {
    marginLeft: `-${spacing(2)}px`,
  },
}));

interface GiftCardLeftProps {
  cardNumber: string;
  removeGiftCard: (cardNumber: string) => void;
}

const GiftCardLeft = ({ cardNumber, removeGiftCard }: GiftCardLeftProps) => {
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [content] = useContent();
  const classes = styles();

  const handleOpenRemoveModal = () => {
    setOpenRemoveModal(true);
  };

  const handleClose = () => {
    setOpenRemoveModal(false);
  };

  const handleRemove = () => {
    setIsLoading(true);
    removeGiftCard(cardNumber);
  };

  const formattedCard = formatCard(cardNumber, content.giftCard.name);
  return (
    <>
      {!!removeGiftCard && (
        <>
          <RemoveButton
            onClick={handleOpenRemoveModal}
            label={`remove ${formattedCard}`}
            className={classes.removeButton}
          />
          <RemoveGiftCardModal
            isOpen={openRemoveModal}
            isLoading={isLoading}
            handleClose={handleClose}
            handleRemove={handleRemove}
          />
        </>
      )}
      {formattedCard}
    </>
  );
};

export default GiftCardLeft;
